module.exports = __webpack_public_path__ + "img/cd-icon-location.svg?fb39fa184954210beda12801ef8835ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cd-icon-location.svg
// module id = 593
// module chunks = 0